const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    lab_ids: {
      type: 'array',
      title: 'labs',
      items: [],
    },
    user_id: {
      type: 'string',
      title: 'مالک',
    },
  },
});

export default schema;
